import * as React from "react";
import {ReactElement} from "react";
import Icon from "../Icon";
import {TravelItemLabel} from "../../../typings/bookingEngine/bookingEngine";

type BookingTravelersItemProps = {
    nbTravelers: number;
    handleRemove: () => void;
    handleAdd: () => void;
    readOnly?: boolean;
    btnLabel: TravelItemLabel;
    children?: React.ReactNode;
};

const BookingTravelersItem = (props: BookingTravelersItemProps): ReactElement => {
    const readOnly = props.readOnly || true;
    const hasChildren = !!props.children;

    return (
        <div className="booking-travelers-item">
            <div className="spinner-content">
                <div className="bt-label">
                    {props.btnLabel.text}
                    <span className="legend">{props.btnLabel.legend}</span>
                </div>
                <div className="spinner-block">
                    <span className="spinner-button spinner-remove" onClick={props.handleRemove}>
                        <div className="icon-wrap icon-less">
                            <Icon icon="w"/>
                        </div>
                    </span>
                    <input type="text" id="ipt_bookingAdults" className="spinner-value nb-adults" value={props.nbTravelers} readOnly={readOnly}/>
                    <span className="spinner-button spinner-add" onClick={props.handleAdd}>
                        <div className="icon-wrap icon-more">
                            <Icon icon="n"/>
                        </div>
                    </span>
                </div>
            </div>
            {hasChildren && props.children}
        </div>
    );
};

export default BookingTravelersItem;